import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import Provider from './theme-provider';
import {
  selectSurveyById,
  selectSurveyByToken,
  selectOrganizationThemeOptions,
} from '../../redux/selectors';
import { pipe } from '../../util';
import { selectResult } from '../../../participant/redux/result/selectors.result';

import resolveEffectiveTheme from './resolve-effective-theme';

export const mapStateToProps = (
  state,
  {
    defaultTheme: defaultThemeName = 'inactive',
    params: { organizationId, surveyId, surveyToken },
  },
) => {
  const result = selectResult(state);
  const survey =
    selectSurveyById(state, result.surveyId || surveyId) || selectSurveyByToken(state, surveyToken);
  const themeOrganizationId = organizationId || (survey && survey.organizationId);
  const organization =
    themeOrganizationId && selectOrganizationThemeOptions(state, themeOrganizationId);

  const orgOptions = result.theme || organization || {};

  return { theme: resolveEffectiveTheme({ survey, orgOptions, defaultThemeName }) };
};

export default pipe(connect(mapStateToProps), withRouter)(Provider);
